import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20260611-widerruf",
        datum: "11.06.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.INFO,
        title: "Widerrufsbutton ab Juni 2026: Wir kümmern uns darum!",
        lizenz: [LizenzEnum.KURSE],
        content: [
            "Zum 19. Juni 2026 treten neue gesetzliche Anforderungen für online abgeschlossene Verträge in Kraft."
            + " Betroffen sind auch Online-Kursanmeldungen über Webseiten.",
            "Gute Nachrichten für alle, die HiOrg-Server KURSE mit öffentlicher TN-Anmeldung nutzen:"
            + " Wir arbeiten bereits an der Umsetzung der neuen Vorgaben und werden die erforderliche Widerrufsfunktion"
            + " rechtzeitig bereitstellen.<br>"
            + "Ihr müsst aktuell nichts unternehmen. Weitere Informationen folgen, sobald die Umsetzung abgeschlossen"
            + " ist.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.LINK,
                text: "Info Verbraucherzentrale",
                url: "https://www.verbraucherzentrale.de/wissen/vertraege-reklamation/widerrufsbutton-ab-juni-2026-onlinevertraege-einfacher-widerrufen-118449",
            },
        ],
    },
];

export {
    insights,
};
